import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  getClientErrorMessage(error: Error): string {
    return error?.message ?? error?.toString();
  }

  getClientStackTrace(error: Error): string {
    return error?.stack ?? '';
  }

  getServerErrorName(error: HttpErrorResponse): string {
    return error?.name;
  }

  getServerErrorMessage(response: HttpErrorResponse): string {
    if (!navigator.onLine) {
      return 'base.error.noInternetConnection';
    }

    const error: any = response?.error?.error;

    if (error != null) {
      return error.message || 'base.error.unexpectedError';
    }

    return response?.message ?? 'base.error.unexpectedError';
  }

  getServerErrorStackTrace(response: HttpErrorResponse): string {
    return response?.message;
  }
}
